import {useSelector as useXstateSelector} from '@xstate/react';

import {customDefaultsXstateActor} from '@/state/machines/custom-defaults';

export default function useCustomDefaultsState() {
	return useXstateSelector(customDefaultsXstateActor, (state) => state.value);
}
